import { ApplicationLogo } from 'components/Logo/ApplicationLogo/ApplicationLogo';
import { ReactNode } from 'react';

export const AuthBodySection = ({ children, heading }: { children: ReactNode; heading: string }) => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <ApplicationLogo variant="dark" className="mx-auto h-11 w-auto" />

      <h2 className="mt-24 text-center text-3xl font-extrabold text-gray-900">{heading}</h2>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex flex-col space-y-6 bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">{children}</div>
      </div>
    </div>
  );
};
